import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Address } from '@cosmos/shared';
import { ErrorService } from '@cosmos/angular/utils';

import { map, Observable, catchError } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AddressService {
  constructor( private http: HttpClient, private errorService: ErrorService ) { }

  find(query=''): Observable<HttpResponse<Address[]>> {
    return this.http
      .get<Address[]>(`${environment.API_URL}/addresses${query}`, {observe: 'response'})
        .pipe(
          map(response => {
          return response;
        }),
        catchError( (error) => {this.errorService.handleError(error); throw error})
      );
  }

  findById(id: string, query=''): Observable<HttpResponse<Address>> {
    return this.http
      .get<Address>(`${environment.API_URL}/addresses/${id}${query}`, {observe: 'response'})
        .pipe(
          map(response => {
          return response;
        }),
        catchError( (error) => {this.errorService.handleError(error); throw error})
      );
  }

  create(body: Address) {
    return this.http
      .post(`${environment.API_URL}/addresses`, body, {observe: 'response'})
        .pipe(
          map(response => {
            return response
          }),
          catchError( (error) => {this.errorService.handleError(error); throw error})
        );
  }

  update(body: any) {
    return this.http
      .patch(`${environment.API_URL}/addresses/${body[0]}`, body[1], {observe: 'response'})
        .pipe(
          map(response => {
            return response;
          }),
          catchError( (error) => {this.errorService.handleError(error); throw error})
        );
  }

  delete(id: string) {
    return this.http
      .delete(`${environment.API_URL}/addresses/${id}`, {observe: 'response'})
        .pipe(
          map(response => {
            return response;
          }),
          catchError( (error) => {this.errorService.handleError(error); throw error})
        );
  }

}
